import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <div className="pt-32 pb-20 px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl font-bold text-black mb-4">Privacy Policy</h1>
          <p className="text-gray-600 mb-12">Last Updated: January 2025</p>

          <div className="space-y-8 text-gray-800">
            <section>
              <h2 className="text-2xl font-bold text-black mb-4 flex items-center">
                <span className="w-2 h-8 bg-gradient-to-b from-yellow-500 to-yellow-600 mr-3 rounded-full"></span>
                Introduction
              </h2>
              <p className="leading-relaxed text-base">
                Rich Luxury Home Builder LLC ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services. Please read this privacy policy carefully. If you do not agree with the terms of this privacy policy, please do not access the site.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-black mb-4 flex items-center">
                <span className="w-2 h-8 bg-gradient-to-b from-yellow-500 to-yellow-600 mr-3 rounded-full"></span>
                Information We Collect
              </h2>
              <div className="space-y-4">
                <div>
                  <h3 className="text-xl font-semibold text-black mb-2">Personal Information</h3>
                  <p className="leading-relaxed text-base mb-2">We may collect personal information that you voluntarily provide to us when you:</p>
                  <ul className="list-disc list-inside space-y-2 ml-4 text-base">
                    <li>Contact us through our website forms</li>
                    <li>Request a consultation or quote</li>
                    <li>Subscribe to our newsletter</li>
                    <li>Communicate with us via email or phone</li>
                  </ul>
                  <p className="leading-relaxed text-base mt-3">This information may include your name, email address, phone number, property address, and project details.</p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-black mb-2">Automatically Collected Information</h3>
                  <p className="leading-relaxed text-base">When you visit our website, we may automatically collect certain information about your device, including:</p>
                  <ul className="list-disc list-inside space-y-2 ml-4 text-base mt-2">
                    <li>IP address and browser type</li>
                    <li>Operating system and device information</li>
                    <li>Pages visited and time spent on pages</li>
                    <li>Referring website addresses</li>
                  </ul>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-black mb-4 flex items-center">
                <span className="w-2 h-8 bg-gradient-to-b from-yellow-500 to-yellow-600 mr-3 rounded-full"></span>
                How We Use Your Information
              </h2>
              <p className="leading-relaxed text-base mb-3">We use the information we collect to:</p>
              <ul className="list-disc list-inside space-y-2 ml-4 text-base">
                <li>Respond to your inquiries and provide customer service</li>
                <li>Process your requests for consultations and quotes</li>
                <li>Send you information about our services and projects</li>
                <li>Improve our website and service offerings</li>
                <li>Analyze website usage and trends</li>
                <li>Comply with legal obligations</li>
                <li>Prevent fraudulent activity and ensure security</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-black mb-4 flex items-center">
                <span className="w-2 h-8 bg-gradient-to-b from-yellow-500 to-yellow-600 mr-3 rounded-full"></span>
                Information Sharing and Disclosure
              </h2>
              <p className="leading-relaxed text-base mb-3">We may share your information in the following circumstances:</p>
              <ul className="list-disc list-inside space-y-2 ml-4 text-base">
                <li><strong className="font-semibold">Service Providers:</strong> We may share information with third-party vendors who perform services on our behalf, such as website hosting, email delivery, and analytics.</li>
                <li><strong className="font-semibold">Business Transfers:</strong> If we are involved in a merger, acquisition, or sale of assets, your information may be transferred as part of that transaction.</li>
                <li><strong className="font-semibold">Legal Requirements:</strong> We may disclose information if required by law or in response to valid legal requests.</li>
                <li><strong className="font-semibold">Protection of Rights:</strong> We may disclose information to protect our rights, property, or safety, or that of our users or others.</li>
              </ul>
              <p className="leading-relaxed text-base mt-3">We do not sell your personal information to third parties.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-black mb-4 flex items-center">
                <span className="w-2 h-8 bg-gradient-to-b from-yellow-500 to-yellow-600 mr-3 rounded-full"></span>
                Cookies and Tracking Technologies
              </h2>
              <p className="leading-relaxed text-base">
                We may use cookies, web beacons, and similar tracking technologies to collect information about your browsing activities. Cookies are small data files stored on your device. You can control cookie settings through your browser preferences, but disabling cookies may limit your ability to use certain features of our website.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-black mb-4 flex items-center">
                <span className="w-2 h-8 bg-gradient-to-b from-yellow-500 to-yellow-600 mr-3 rounded-full"></span>
                Data Security
              </h2>
              <p className="leading-relaxed text-base">
                We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-black mb-4 flex items-center">
                <span className="w-2 h-8 bg-gradient-to-b from-yellow-500 to-yellow-600 mr-3 rounded-full"></span>
                Your Privacy Rights
              </h2>
              <p className="leading-relaxed text-base mb-3">Depending on your location, you may have certain rights regarding your personal information, including:</p>
              <ul className="list-disc list-inside space-y-2 ml-4 text-base">
                <li>The right to access and receive a copy of your personal information</li>
                <li>The right to correct inaccurate or incomplete information</li>
                <li>The right to request deletion of your personal information</li>
                <li>The right to object to or restrict certain processing activities</li>
                <li>The right to withdraw consent where processing is based on consent</li>
              </ul>
              <p className="leading-relaxed text-base mt-3">To exercise these rights, please contact us using the information provided below.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-black mb-4 flex items-center">
                <span className="w-2 h-8 bg-gradient-to-b from-yellow-500 to-yellow-600 mr-3 rounded-full"></span>
                Third-Party Links
              </h2>
              <p className="leading-relaxed text-base">
                Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of these external sites. We encourage you to review the privacy policies of any third-party sites you visit.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-black mb-4 flex items-center">
                <span className="w-2 h-8 bg-gradient-to-b from-yellow-500 to-yellow-600 mr-3 rounded-full"></span>
                Children's Privacy
              </h2>
              <p className="leading-relaxed text-base">
                Our services are not directed to individuals under the age of 18. We do not knowingly collect personal information from children. If we become aware that we have collected information from a child without parental consent, we will take steps to delete that information.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-black mb-4 flex items-center">
                <span className="w-2 h-8 bg-gradient-to-b from-yellow-500 to-yellow-600 mr-3 rounded-full"></span>
                Changes to This Privacy Policy
              </h2>
              <p className="leading-relaxed text-base">
                We may update this Privacy Policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons. We will notify you of any material changes by posting the updated policy on our website with a new "Last Updated" date. Your continued use of our website after such changes constitutes your acceptance of the updated policy.
              </p>
            </section>

            <section className="bg-gradient-to-r from-yellow-50 to-yellow-100 p-8 rounded-lg border-l-4 border-yellow-500">
              <h2 className="text-2xl font-bold text-black mb-4 flex items-center">
                <span className="w-2 h-8 bg-gradient-to-b from-yellow-500 to-yellow-600 mr-3 rounded-full"></span>
                Contact Us
              </h2>
              <p className="leading-relaxed text-base mb-4">
                If you have any questions, concerns, or requests regarding this Privacy Policy or our privacy practices, please contact us:
              </p>
              <div className="space-y-2 text-base">
                <p className="flex items-center">
                  <i className="ri-building-line text-yellow-600 mr-3 w-5 h-5 flex items-center justify-center"></i>
                  <strong className="font-semibold mr-2">Company:</strong> Rich Luxury Home Builder LLC
                </p>
                <p className="flex items-start">
                  <i className="ri-map-pin-line text-yellow-600 mr-3 w-5 h-5 flex items-center justify-center mt-1"></i>
                  <span><strong className="font-semibold mr-2">Address:</strong> 112 W Pipeline Rd Suite 6, Hurst, TX 76053</span>
                </p>
                <p className="flex items-center">
                  <i className="ri-phone-line text-yellow-600 mr-3 w-5 h-5 flex items-center justify-center"></i>
                  <strong className="font-semibold mr-2">Phone:</strong> 214-864-0689
                </p>
                <p className="flex items-center">
                  <i className="ri-mail-line text-yellow-600 mr-3 w-5 h-5 flex items-center justify-center"></i>
                  <strong className="font-semibold mr-2">Email:</strong> richluxuryhb01@gmail.com
                </p>
              </div>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
